export const STAGE = window.location.hostname === 'www.aesthetixconnect.com' ? "client-api" : "dev-api";
export const PREFIX = window.location.hostname === 'www.aesthetixconnect.com' ? "" : "dev-";
